import { Input, Select } from "../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import CustomDatePicker from "../../../components/CustomDatePicker.tsx";
import { useContext, useMemo } from "react";
import { DataContext } from "../../../dataProviders/DataProvider.tsx";
import { useFilter } from "../hooks/useFilter.ts";
import css from "../Transactions.module.css";
import { SelectOption } from "../../../components/Select/Select.tsx";
import { getAccountName } from "../../../utils/tableHelpers.tsx";
import { MAX_TRANSACTIONS_DATE, MIN_TRANSACTIONS_DATE } from "../../../utils/transactions.ts";
import { t } from "@lingui/macro";

interface Props {
  filter: ReturnType<typeof useFilter>;
  isDisabled: boolean;
}

export function Filter({ filter, isDisabled }: Props) {
  const selectDirection = [
    { value: "all", label: t`Všechny` },
    { value: "DBIT", label: t`Odchozí` },
    { value: "CRDT", label: t`Příchozí` },
  ];

  const selectStatus = [
    { value: "all", label: t`Všechny` },
    { value: "BOOK", label: t`Zaúčtováno` },
    { value: "PDNG", label: t`Blokováno` },
  ];

  const { accountsData } = useContext(DataContext);

  const selectAccount = useMemo(() => {
    const select: SelectOption<string>[] = [{ label: t`Všechny`, value: "all" }];
    for (const key in accountsData) {
      const label = getAccountName(accountsData[key]);
      select.push({
        label: label,
        value: key,
        slot: (
          <img
            className={"w-6 h-6 object-contain max-w-none shrink-0"}
            src={accountsData[key].bank.identification.logoUrl}
            alt={accountsData[key].bank.identification.name}
          />
        ),
      });
    }
    return select;
  }, [accountsData]);

  return (
    <>
      <Input
        value={filter.search}
        onChange={(e) => filter.setSearch(e.target.value)}
        disabled={isDisabled}
        placeholder={t`Zadejte IBAN, jméno, název účtu...`}
        containerProps={{ className: "max-w-md" }}
        icon={<FontAwesomeIcon icon={faMagnifyingGlass} />}
      />

      <div className={css.filters}>
        <div className={css.selectWrapper}>
          <Select
            disabled={isDisabled}
            value={filter.filterAccounts}
            variant={"secondary"}
            label={t`Účty`}
            size={"lg"}
            onChange={filter.changeFilterAccounts}
            options={selectAccount}
            className={"flex-1"}
          />
          <Select
            disabled={isDisabled}
            value={filter.filterDirection}
            variant={"secondary"}
            label={t`Směr transakce`}
            size={"lg"}
            onChange={filter.changeFilterDirection}
            options={selectDirection}
            className={"flex-1"}
          />
          <Select
            disabled={isDisabled}
            value={filter.filterStatus}
            variant={"secondary"}
            label={t`Stav transakce`}
            size={"lg"}
            onChange={filter.changeFilterStatus}
            options={selectStatus}
            className={"flex-1"}
          />
        </div>
        <div className={css.datePickerWrapper}>
          <CustomDatePicker
            value={filter.startDate}
            text={t`Vyberte období`}
            label={t`Datum od`}
            minDate={MIN_TRANSACTIONS_DATE}
            maxDate={MAX_TRANSACTIONS_DATE}
            onChange={filter.changeFilterStart}
            onClear={() => filter.changeFilterStart(null)}
            size={"lg"}
            className={"flex-1"}
          />
          <CustomDatePicker
            value={filter.endDate}
            text={t`Vyberte období`}
            label={t`Datum do`}
            minDate={MIN_TRANSACTIONS_DATE}
            maxDate={MAX_TRANSACTIONS_DATE}
            onChange={filter.changeFilterEnd}
            onClear={() => filter.changeFilterEnd(null)}
            size={"lg"}
            className={"flex-1"}
          />
        </div>
      </div>
    </>
  );
}
